module.exports = __webpack_public_path__ + "img/logo grey.f44eea43.svg";